import React from "react";
import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ButtonTypes } from "../../../../../components/Button";

import { REFRESH_NOTICE_RETRY_LABEL, RETRYING_NOTICE_COPY } from "./constants";
import { Notice, RetryButton, SpinningIcon } from "./styles";
import { RefreshNoticeProps } from "./types";

const ICON_SIZE = 19;

export const RefreshNotice: React.FC<RefreshNoticeProps> = ({
  title,
  detail,
  isRetrying,
  isSecondary = false,
  onRetry,
}) => {
  const role = isRetrying || isSecondary ? "status" : "alert";
  const copy = isRetrying ? RETRYING_NOTICE_COPY : { title, detail };
  const buttonLabel = isRetrying
    ? RETRYING_NOTICE_COPY.buttonLabel
    : REFRESH_NOTICE_RETRY_LABEL;
  const icon = isRetrying ? (
    <SpinningIcon aria-hidden="true">
      <RefreshIcon sx={{ fontSize: ICON_SIZE }} />
    </SpinningIcon>
  ) : (
    <CloudOffOutlinedIcon aria-hidden="true" sx={{ fontSize: ICON_SIZE }} />
  );

  return (
    <Notice $isRetrying={isRetrying} role={role} aria-atomic="true">
      {icon}
      <div>
        <strong>{copy.title}</strong>
        <p>{copy.detail}</p>
      </div>
      <RetryButton
        type={ButtonTypes.primary}
        size="small"
        isLoading={isRetrying}
        onClick={onRetry}
      >
        {buttonLabel}
      </RetryButton>
    </Notice>
  );
};
